document.addEventListener("DOMContentLoaded", function () {
  const footerEl = document.querySelector(".site-footer--new__mobile");

  if (!footerEl) return;

  const mobileNavItems = footerEl.querySelectorAll("[js-footer-nav-item]");

  mobileNavItems.forEach((el) => {
    const submenuToggleBtn = el.querySelector(".submenu-toggle-btn");
    const submenu = el.querySelector(".footer--middle-nav_mobile-list-item-submenu-wrapper");

    if (submenuToggleBtn && submenu) {
      submenuToggleBtn.addEventListener("click", () => toggleSubmenu(submenuToggleBtn, submenu));
    }
  });

  function toggleSubmenu(btn, submenu) {
    const isOpen = btn.getAttribute("aria-expanded") === "true";

    if (isOpen) {
      btn.setAttribute("aria-expanded", false);
      submenu.classList.remove("--expanded");
    } else {
      mobileNavItems.forEach((el) => {
        const submenuToggleBtn = el.querySelector(".submenu-toggle-btn");
        const sub = el.querySelector(".footer--middle-nav_mobile-list-item-submenu-wrapper");

        if (submenuToggleBtn && sub) {
          submenuToggleBtn.setAttribute("aria-expanded", false);
          sub.classList.remove("--expanded");
        }
      });

      btn.setAttribute("aria-expanded", true);
      submenu.classList.add("--expanded");
    }
  }

  // For Map - Desktop
  // if (locationDataDesktop) {
  //   var cities = locationDataDesktop;
  // } else {
  //   var cities = [
  //     {
  //       name: "KA/NOA Geneva",
  //       x: 29.3,
  //       y: 76.3,
  //       address: "Rue verdaine 13, <br> 1204 Genève, <br>Switzerland.",
  //       phone: "+41 22 311 3981",
  //       phoneLink: "tel:+41223113981",
  //       email: "geneve@kanoaitalia.com",
  //       emailLink: "mailto:geneve@kanoaitalia.com",
  //     },
  //     {
  //       name: "KA/NOA Lausanne",
  //       x: 33.5,
  //       y: 61,
  //       address: "Rue du Grand-Chêne 7,<br> 1003 Lausanne,<br> Switzerland.",
  //       phone: "+41 21 311 3981",
  //       phoneLink: "tel:+41213113981",
  //       email: "lausanne@kanoaitalia.com",
  //       emailLink: "mailto:lausanne@kanoaitalia.com",
  //     },
  //     {
  //       name: "KA/NOA Zurich",
  //       x: 49.3,
  //       y: 21.3,
  //       address: "24, Rennweg,<br>8001 Zürich, <br>Switzerland.",
  //       phone: "+41 44 300 3981",
  //       phoneLink: "tel:+41443003981",
  //       email: "zurich@kanoaitalia.com",
  //       emailLink: "mailto:zurich@kanoaitalia.com",
  //     },
  //   ];
  // }

  // const pointerContainer = document.getElementById("map-pointers");
  // const popup = document.getElementById("map-popup");
  // const popupTitle = document.querySelector(".popup .popup-title");
  // const popupAddress = document.querySelector(".popup .popup-address");
  // const popupPhone = document.querySelector(".popup .popup-phone");
  // const popupEmail = document.querySelector(".popup .popup-email");
  // const closeButton = document.querySelector(".popup .popup-close");

  // cities.forEach((city) => {
  //   const pointer = document.createElement("div");
  //   pointer.classList.add("map-pointer");
  //   pointer.style.left = `${city.x}%`;
  //   pointer.style.top = `${city.y}%`;

  //   pointer.addEventListener("click", (event) => {
  //     event.stopPropagation();

  //     popupTitle.textContent = city.name;
  //     popupAddress.innerHTML = city.address;
  //     popupPhone.textContent = city.phone;
  //     popupPhone.href = city.phoneLink;
  //     popupEmail.textContent = city.email;
  //     popupEmail.href = city.emailLink;

  //     popup.style.left = `calc(${city.x}% - 13%)`;
  //     popup.style.top = `calc(${city.y}% + 15px)`;
  //     popup.classList.add("show");
  //   });

  //   pointerContainer.appendChild(pointer);
  // });

  // // Close popup when clicking outside
  // document.addEventListener("click", (event) => {
  //   if (!popup.contains(event.target) && !event.target.classList.contains("map-pointer")) {
  //     popup.classList.remove("show");
  //   }
  // });

  // // Close popup when clicking the close button
  // closeButton.addEventListener("click", () => {
  //   popup.classList.remove("show");
  // });

  function initMapPointers({ data, pointerContainerId, popupId, otherPopupId }) {
    const container = document.getElementById(pointerContainerId);
    const popup = document.getElementById(popupId);
    const otherPopup = document.getElementById(otherPopupId);

    const title = popup.querySelector(".popup-title");
    const address = popup.querySelector(".popup-address");
    const phone = popup.querySelector(".popup-phone");
    const email = popup.querySelector(".popup-email");
    const closeBtn = popup.querySelector(".popup-close");
    const locationLink = popup.querySelector(".block-location-link");

    data.forEach((city) => {
      const pointer = document.createElement("div");
      pointer.classList.add("map-pointer");
      pointer.style.left = `${city.x}%`;
      pointer.style.top = `${city.y}%`;

      pointer.addEventListener("click", (e) => {
        e.stopPropagation();

        // Close other popup
        if (otherPopup) otherPopup.classList.remove("show");

        // Fill and show this popup
        title.textContent = city.name;
        address.innerHTML = city.address;
        phone.textContent = city.phone;
        phone.href = city.phoneLink;
        email.textContent = city.email;
        email.href = city.emailLink;
        locationLink.href = city.location_link;

        popup.style.left = `calc(${city.x}% - 13%)`;
        popup.style.top = `calc(${city.y}% + 25px)`;
        popup.classList.add("show");
      });

      container.appendChild(pointer);
    });

    closeBtn.addEventListener("click", () => {
      popup.classList.remove("show");
    });

    // Close popup on outside click
    document.addEventListener("click", (e) => {
      if (!popup.contains(e.target) && !e.target.classList.contains("map-pointer")) {
        popup.classList.remove("show");
      }
    });
  }

  // --- Data ---
  const cities =
    typeof locationDataDesktop !== "undefined"
      ? locationDataDesktop
      : [
          {
            name: "KA/NOA Geneva",
            x: 36.4,
            y: 76,
            address: "Rue verdaine 13, <br> 1204 Genève, <br>Switzerland.",
            phone: "+41 22 311 3981",
            phoneLink: "tel:+41223113981",
            email: "geneve@kanoaitalia.com",
            emailLink: "mailto:geneve@kanoaitalia.com",
          },
          {
            name: "KA/NOA Lausanne",
            x: 39.35,
            y: 61.2,
            address: "Rue du Grand-Chêne 7,<br> 1003 Lausanne,<br> Switzerland.",
            phone: "+41 21 311 3981",
            phoneLink: "tel:+41213113981",
            email: "lausanne@kanoaitalia.com",
            emailLink: "mailto:lausanne@kanoaitalia.com",
          },
          {
            name: "KA/NOA Zurich",
            x: 50.75,
            y: 21.1,
            address: "24, Rennweg,<br>8001 Zürich, <br>Switzerland.",
            phone: "+41 44 300 3981",
            phoneLink: "tel:+41443003981",
            email: "zurich@kanoaitalia.com",
            emailLink: "mailto:zurich@kanoaitalia.com",
          },
        ];

  const otherCities =
    typeof otherLocationDataDesktop !== "undefined"
      ? otherLocationDataDesktop
      : [
          {
            name: "Crans-Montana",
            x: 45,
            y: 65,
            address: "",
            phone: "",
            phoneLink: "",
            email: "",
            emailLink: "",
          },
          {
            name: "Verbier",
            x: 46,
            y: 81,
            address: "7, Rue de Médran,<br>1936 Verbier,<br>Switzerland.",
            phone: "+41 27 323 3981",
            phoneLink: "tel:+41273233981",
            email: "verbier@kanoaitalia.com",
            emailLink: "mailto:verbier@kanoaitalia.com",
          },
          {
            name: "St-Moritz",
            x: 58.5,
            y: 59,
            address: "",
            phone: "",
            phoneLink: "",
            email: "",
            emailLink: "",
          },
        ];

  // Initialize maps
  initMapPointers({
    data: cities,
    pointerContainerId: "map-pointers",
    popupId: "map-popup",
    otherPopupId: "map-popup--otherCities",
  });

  initMapPointers({
    data: otherCities,
    pointerContainerId: "map-pointers--otherCities",
    popupId: "map-popup--otherCities",
    otherPopupId: "map-popup",
  });

  // For Map - Mobile
  // if (locationDataMobile) {
  //   var citiesMobile = locationDataMobile;
  // } else {
  //   var citiesMobile = [
  //     {
  //       name: "KA/NOA Geneva",
  //       x: 19.2,
  //       y: 71.5,
  //       address: "Rue verdaine 13, <br> 1204 Genève, <br>Switzerland.",
  //       phone: "+41 22 311 3981",
  //       phoneLink: "tel:+41223113981",
  //       email: "geneve@kanoaitalia.com",
  //       emailLink: "mailto:geneve@kanoaitalia.com",
  //     },
  //     {
  //       name: "KA/NOA Lausanne",
  //       x: 27.5,
  //       y: 60,
  //       address: "Rue du Grand-Chêne 7,<br> 1003 Lausanne,<br> Switzerland.",
  //       phone: "+41 21 311 3981",
  //       phoneLink: "tel:+41213113981",
  //       email: "lausanne@kanoaitalia.com",
  //       emailLink: "mailto:lausanne@kanoaitalia.com",
  //     },
  //     {
  //       name: "KA/NOA Zurich",
  //       x: 59,
  //       y: 29.3,
  //       address: "24, Rennweg,<br>8001 Zürich, <br>Switzerland.",
  //       phone: "+41 44 300 3981",
  //       phoneLink: "tel:+41443003981",
  //       email: "zurich@kanoaitalia.com",
  //       emailLink: "mailto:zurich@kanoaitalia.com",
  //     },
  //   ];
  // }

  // const pointerContainerMobile = document.getElementById("map-pointers--mobile");
  // const popupMobile = document.getElementById("map-popup--mobile");
  // const popupTitleMobile = document.querySelector(".popup--mobile .popup-title");
  // const popupAddressMobile = document.querySelector(".popup--mobile .popup-address");
  // const popupPhoneMobile = document.querySelector(".popup--mobile .popup-phone");
  // const popupEmailMobile = document.querySelector(".popup--mobile .popup-email");
  // const closeButtonMobile = document.querySelector(".popup--mobile .popup-close");

  // citiesMobile.forEach((city) => {
  //   const pointer = document.createElement("div");
  //   pointer.classList.add("map-pointer");
  //   pointer.style.left = `${city.x}%`;
  //   pointer.style.top = `${city.y}%`;

  //   pointer.addEventListener("click", (event) => {
  //     event.stopPropagation();

  //     popupTitleMobile.textContent = city.name;
  //     popupAddressMobile.innerHTML = city.address;
  //     popupPhoneMobile.textContent = city.phone;
  //     popupPhoneMobile.href = city.phoneLink;
  //     popupEmailMobile.textContent = city.email;
  //     popupEmailMobile.href = city.emailLink;

  //     popupMobile.style.left = `calc(${city.x}% - 13%)`;
  //     popupMobile.style.top = `calc(${city.y}% + 25px)`;
  //     popupMobile.classList.add("show");
  //   });

  //   pointerContainerMobile.appendChild(pointer);
  // });

  // // Close popup when clicking outside
  // document.addEventListener("click", (event) => {
  //   if (!popupMobile.contains(event.target) && !event.target.classList.contains("map-pointer")) {
  //     popupMobile.classList.remove("show");
  //   }
  // });

  // // Close popup when clicking the close button
  // closeButtonMobile.addEventListener("click", () => {
  //   popupMobile.classList.remove("show");
  // });

  function initMapPointersMobile({ data, pointerContainerId, popupId, otherPopupId }) {
    const container = document.getElementById(pointerContainerId);
    const popup = document.getElementById(popupId);
    const otherPopup = document.getElementById(otherPopupId);

    const title = popup.querySelector(".popup-title");
    const address = popup.querySelector(".popup-address");
    const phone = popup.querySelector(".popup-phone");
    const email = popup.querySelector(".popup-email");
    const closeBtn = popup.querySelector(".popup-close");
     const locationLink = popup.querySelector(".block-location-link");

    data.forEach((city) => {
      const pointer = document.createElement("div");
      pointer.classList.add("map-pointer");
      pointer.style.left = `${city.x}%`;
      pointer.style.top = `${city.y}%`;

      pointer.addEventListener("click", (e) => {
        e.stopPropagation();

        // Close other popup
        if (otherPopup) otherPopup.classList.remove("show");

        // Fill and show this popup
        title.textContent = city.name;
        address.innerHTML = city.address;
        phone.textContent = city.phone;
        phone.href = city.phoneLink;
        email.textContent = city.email;
        email.href = city.emailLink;
        locationLink.href = city.location_link;
        popup.style.left = `calc(${city.x}% - 13%)`;
        popup.style.top = `calc(${city.y}% + 25px)`;
        popup.classList.add("show");
      });

      container.appendChild(pointer);
    });

    closeBtn.addEventListener("click", () => {
      popup.classList.remove("show");
    });

    // Close popup on outside click
    document.addEventListener("click", (e) => {
      if (!popup.contains(e.target) && !e.target.classList.contains("map-pointer")) {
        popup.classList.remove("show");
      }
    });
  }

  // --- Data ---
  const citiesMobile =
    typeof locationDataMobile !== "undefined"
      ? locationDataMobile
      : [
          {
            name: "KA/NOA Geneva",
            x: 19.2,
            y: 71.5,
            address: "Rue verdaine 13, <br> 1204 Genève, <br>Switzerland.",
            phone: "+41 22 311 3981",
            phoneLink: "tel:+41223113981",
            email: "geneve@kanoaitalia.com",
            emailLink: "mailto:geneve@kanoaitalia.com",
          },
          {
            name: "KA/NOA Lausanne",
            x: 27.5,
            y: 60,
            address: "Rue du Grand-Chêne 7,<br> 1003 Lausanne,<br> Switzerland.",
            phone: "+41 21 311 3981",
            phoneLink: "tel:+41213113981",
            email: "lausanne@kanoaitalia.com",
            emailLink: "mailto:lausanne@kanoaitalia.com",
          },
          {
            name: "KA/NOA Zurich",
            x: 59,
            y: 29.3,
            address: "24, Rennweg,<br>8001 Zürich, <br>Switzerland.",
            phone: "+41 44 300 3981",
            phoneLink: "tel:+41443003981",
            email: "zurich@kanoaitalia.com",
            emailLink: "mailto:zurich@kanoaitalia.com",
          },
        ];

  const otherCitiesMobile =
    typeof otherLocationDataMobile !== "undefined"
      ? otherLocationDataMobile
      : [
          {
            name: "Crans-Montana",
            x: 45,
            y: 65,
            address: "",
            phone: "",
            phoneLink: "",
            email: "",
            emailLink: "",
          },
          {
            name: "Verbier",
            x: 47,
            y: 75,
            address: "7, Rue de Médran,<br>1936 Verbier,<br>Switzerland.",
            phone: "+41 27 323 3981",
            phoneLink: "tel:+41273233981",
            email: "verbier@kanoaitalia.com",
            emailLink: "mailto:verbier@kanoaitalia.com",
          },
          {
            name: "St-Moritz",
            x: 81.5,
            y: 59,
            address: "",
            phone: "",
            phoneLink: "",
            email: "",
            emailLink: "",
          },
        ];

  // Initialize maps
  initMapPointersMobile({
    data: citiesMobile,
    pointerContainerId: "map-pointers--mobile",
    popupId: "map-popup--mobile",
    otherPopupId: "map-popup--otherCities-mobile",
  });

  initMapPointersMobile({
    data: otherCitiesMobile,
    pointerContainerId: "map-pointers--otherCities-mobile",
    popupId: "map-popup--otherCities-mobile",
    otherPopupId: "map-popup--mobile",
  });
});